
/* eslint-disable no-unused-vars */
import featureFlags from 'shared/lib/featureFlags';
import { DEVELOPMENT_MODE, DEFAULT_LANGUAGE_CODE, DEFAULT_CURRENCY } from 'shared/constants';

export default (trackingId) => {
  const pushToGa = (...args) => {
    if (DEVELOPMENT_MODE || featureFlags.logger) {
      const titleArgs = ['%c GOOGLE ANALYTICS', 'color: orange'];
      console.group(...titleArgs);
      console.log('\t', ...args);
      console.groupEnd(...titleArgs);
    }

    if (window.gtag) {
      window.gtag(...args);
    }
  };

  const addConfig = payload => pushToGa('config', trackingId, payload);

  return {
    setUserId(userId) {
      // addConfig({ user_id: userId });
    },
    setLanguage(language) {
      // addConfig({ user_language: language || DEFAULT_LANGUAGE_CODE });
    },
    setCurrency(currency) {
      // addConfig({ currency: currency || DEFAULT_CURRENCY });
    },
    event(name, payload) {
      pushToGa('event', name, payload);
    }
  };
};
